import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <p className="font-saira font-semibold text-lg">Reliance Motor Claims Recovery</p>
            <p className="mt-2 text-sm text-white/70">ABN 35 696 990 851</p>
            <p className="mt-4 text-sm text-white/70 leading-relaxed">
              Not-at-fault accident claims recovery – we manage your claim, replacement hire
              vehicle, storage and repairs, and claim the costs from the at-fault party's insurer.
            </p>
          </div>

          <div>
            <p className="font-saira font-semibold text-base">Contact</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href="tel:1800957474"
                  className="inline-flex items-center gap-2 min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4"
                  data-testid="footer-phone-link"
                >
                  <Phone className="size-4" aria-hidden="true" /> 1800 957 474
                </a>
              </li>
              <li>
                <a
                  href="mailto:claims@reliancemotorclaims.com.au"
                  className="inline-flex items-center gap-2 min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4 break-all"
                  data-testid="footer-email-link"
                >
                  <Mail className="size-4 shrink-0" aria-hidden="true" /> claims@reliancemotorclaims.com.au
                </a>
              </li>
              <li className="inline-flex items-start gap-2 text-white/80">
                <Clock className="size-4 mt-0.5 shrink-0" aria-hidden="true" />
                <span>Mon–Fri 8:30am–5:30pm<br />Sat 9am–1pm</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-saira font-semibold text-base">Pages</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" to="/" data-testid="footer-nav-home">Home</Link></li>
              <li><Link className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" to="/services" data-testid="footer-nav-services">Services</Link></li>
              <li><Link className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" to="/accident-help" data-testid="footer-nav-accident-help">Accident? What to do</Link></li>
              <li><Link className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" to="/about" data-testid="footer-nav-about">About</Link></li>
              <li><Link className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" to="/contact" data-testid="footer-nav-contact">Contact</Link></li>
              <li><Link className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" to="/privacy" data-testid="footer-nav-privacy">Privacy</Link></li>
              <li><a className="inline-flex items-center min-h-[32px] text-white/80 hover:text-white hover:underline decoration-road decoration-2 underline-offset-4" href="/claim" data-testid="footer-start-claim-link">Start your claim</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10">
          <p className="text-sm text-white/60">© {year} Reliance Motor Claims Recovery</p>
        </div>
      </div>
    </footer>
  );
}
